import { Component, Input } from '@angular/core';

/**
 * Generated class for the RmtSkeletonLoaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-skeleton-loader',
  templateUrl: 'rmt-skeleton-loader.html'
})
export class RmtSkeletonLoaderComponent {
  @Input() isLoading: false;
  @Input() lines: Number;
  @Input() lineWidth: string;
  @Input() lineHeight: string = '24px';
  @Input() lineMarginTop: string = '24px';
  @Input() padding: boolean = true;
  @Input() small: boolean = false;
  fakeLinesArray = [];


  ngOnInit() {
    if (this.small) {
      this.padding = false;
      this.lines = 1;
      this.lineHeight = '12px';
      this.lineMarginTop = '0px';
      if (!this.lineWidth)
        this.lineWidth = '100px';      
    }

    if (this.lines === undefined) {
      this.lines = 6;
    }

    this.fakeLinesArray = new Array(this.lines);

    for (let index = 0; index < this.fakeLinesArray.length; index++) {
      this.fakeLinesArray[index] = this.getWidthFor();
    }
  }

  getWidthFor() {
    if (this.lineWidth)
      return this.lineWidth;
    const percentages = ['30%', '50%', '70%', '80%', '100%'];
    const randomNumber = Math.floor(Math.random() * percentages.length);
    return percentages[randomNumber];
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-skeleton-loader/rmt-skeleton-loader.ts